<script setup lang="ts">
import { toHead } from 'vue-datocms'
import { queryIndex } from '~/graphql/queries/home'
import { ApiErrorType } from '~/types'

const { resolveSectionComponent } = useResolveComponent()
const { throwError, handleApiError } = useApiError()
const { locale } = useI18n()

const { data, error } = await useDatoQuery(queryIndex, {
  variables: {
    locale: locale.value
  }
})

if (error.value) {
  handleApiError(error.value)
}

if (!data.value?.index) {
  throwError(ApiErrorType.NOT_FOUND)
}

if (data.value?.index?.seoMetadata?.noIndex || !data.value?.index?.publishTranslation) {
  useRobotsRule('noindex, nofollow')
}

const i18nHead = useLocaleHead()

useHead(() => ({
  ...toHead(data.value?.index?._seoMetaTags || []),
  link: [...(i18nHead.value.link || [])]
}))
</script>

<template>
  <div v-if="data?.index">
    <component
      :is="resolveSectionComponent(item.__typename as SectionComponents)"
      v-for="(item, index) in data.index?.main"
      :key="item.id"
      :data="item"
      :module-index="index"
    />
  </div>
</template>
